import type { LedgerSortDirection } from "../types/ledger";

/** Empty and unparseable values sort after dated rows. */
export function compareOptionalInstant(
  left: string | undefined,
  right: string | undefined,
  direction: LedgerSortDirection,
): number {
  const leftMs = parseInstant(left);
  const rightMs = parseInstant(right);
  if (leftMs === undefined && rightMs === undefined) return 0;
  if (leftMs === undefined) return 1;
  if (rightMs === undefined) return -1;
  const result = leftMs - rightMs;
  return direction === "asc" ? result : -result;
}

function parseInstant(value: string | undefined): number | undefined {
  if (!value) return undefined;
  const ms = Date.parse(value);
  return Number.isNaN(ms) ? undefined : ms;
}
